import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly httpClient = inject(HttpClient);

  getVersion(): Observable<string> {
    return this.httpClient.get('/version.txt', {
      responseType: 'text',
    });
  }
}
